<template>
<div ref="PetXcxEdit">    
    <div class="TTL-el-form-search-regular">
        <div class="TTL-button TTL-btn-option">
        <el-button @click="submitData">提交数据</el-button>
        </div>
    </div>
    
    <!-- 数据调整 -->
    <div class="TTL-cate-infos">
        
        <!-- 系统属性设置 -->
        <div class="TTL-cate-sys-1">
            <div class="TTL-cate-title top10">
                系统属性
                <div class="TTL-button TTL-btn-option">
                <el-button @click="createAttribute">生成属性</el-button>
                </div>
            </div>
            <div class="TTL-cate-list top10">
                <div class="TTL-cate-label-1" v-for="(item,index) in labels" :key="index">
                    <div class="TTL-cate-item">
                    <div class="TTL-checkbox">
                    <el-checkbox v-model="item.show"  :indeterminate="item.iselect==2 ? true : false"  @change="changeLabels(item,'-1')" />
                    </div>
                    <span class="TTL-label-name">{{item.name}}</span>
                    </div>
                    <div class="TTL-cate-child" v-for="(t,i) in item.children" :key="i">
                        <div class="TTL-cate-label-1">
                            <div class="TTL-cate-item">
                            <div class="TTL-checkbox">
                            <el-checkbox v-model="t.show" :indeterminate="t.iselect==2 ? true : false" @change="changeLabels(t,index)" />
                            </div>
                            <span class="TTL-label-name">{{t.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 自定义属性 -->
        <div class="TTL-cate-sys-1 left40">
            <div class="TTL-cate-title top10">一级属性<i>（鼠标拖拽排序）</i></div>
            <div class="TTL-cate-list top10">
                <draggable v-model="mylabel" @start="true" @end="false">
                    <template #item="{element}">
                    <div class="TTL-cate-label-3" @click="showChild(element.id)">
                        <div class="TTL-cate-item">
                        <span class="TTL-label-name">{{element.name}}</span>
                        </div>
                    </div>
                    </template>
                </draggable>
            </div>
        </div>

        <!-- 自定义二级属性 -->
        <div class="TTL-cate-sys-1 left40">
            <div class="TTL-cate-title top10">二级属性<i>（鼠标拖拽排序）</i></div>
            <div class="TTL-cate-list top10">
                <draggable v-model="childs" @start="true" @end="finishchild">
                    <template #item="{element}">
                    <div class="TTL-cate-label-3">
                        <div class="TTL-cate-item">
                        <span class="TTL-label-name">{{element.name}}</span>
                        </div>
                    </div>
                    </template>
                </draggable>
            </div>
        </div>

        <!-- 显示效果 -->
        <div class="TTL-cate-sys-1 left40">
            <div class="TTL-cate-title top10">显示效果</div>
            <div class="TTL-cate-list top10">
                <div class="TTL-cate-label-2" v-for="(item,index) in mylabel" :key="index">
                    <div class="TTL-cate-item">
                    <span class="TTL-label-name">{{item.name}}</span>
                    </div>
                    <div class="TTL-cate-child" v-for="(t,i) in item.children" :key="i" style="padding:0">
                        <div class="TTL-cate-label-3" style="padding:0;width:100%">
                            <div class="TTL-cate-item">
                            <span class="TTL-label-name">{{t.name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



    </div>
</div>
</template>

<script>
import draggable from 'vuedraggable';
import INTERFACE_SETTING from '@/Interface/Shop/setting';
export default {
    components: {draggable},
    data() {
        return {
            labels:[
                {id:1,name:'性别',show:false,iselect:0,children:[
                    {id:2,name:'哥哥',show:false,iselect:0,children:[]},
                    {id:3,name:'妹妹',show:false,iselect:0,children:[]},
                    {id:4,name:'不确定',show:false,iselect:0,children:[]},
                ]},
                {id:5,name:'是否绝育',show:false,iselect:0,children:[
                    {id:6,name:'已绝育',show:false,iselect:0,children:[]},
                    {id:7,name:'未绝育',show:false,iselect:0,children:[]},
                ]},
                {id:8,name:'是否种公',show:false,iselect:0,children:[
                    {id:9,name:'种公',show:false,iselect:0,children:[]},
                    {id:10,name:'非种公',show:false,iselect:0,children:[]},
                ]},
                {id:11,name:'疫苗',show:false,iselect:0,children:[
                    {id:12,name:'一针',show:false,iselect:0,children:[]},
                    {id:13,name:'二针',show:false,iselect:0,children:[]},
                    {id:14,name:'三针',show:false,iselect:0,children:[]},
                    {id:15,name:'狂犬疫苗',show:false,iselect:0,children:[]},
                    {id:16,name:'乙肝疫苗',show:false,iselect:0,children:[]},
                ]},
                {id:17,name:'是否驱虫',show:false,iselect:0,children:[
                    {id:18,name:'已驱虫',show:false,iselect:0,children:[]},
                    {id:19,name:'未驱虫',show:false,iselect:0,children:[]},
                ]},
                {id:20,name:'所属房间',show:false,iselect:0,children:[
                    {id:21,name:'房间1',show:false,iselect:0,children:[]},
                    {id:22,name:'房间2',show:false,iselect:0,children:[]},
                    {id:23,name:'房间3',show:false,iselect:0,children:[]},
                ]},
            ],

            mylabel:[],
            childs:[],
            selectid:'',

        }
    },

    mounted() {
        this.OnloadMethod(); //页数初始化
    },

    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod() {
            this.GetXcxPetCate();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {

            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.GetXcxPetCate();

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }

        },



        /** 提交数据 **/
        submitData() {
            if(this.mylabel.length==0) {this.$notice({title:'错误提示',type:'warning',message:'请选择要设置的属性信息'});return false;}
            //给属性信息标记排序信息
            var sort=0; var subsort=0;
            for(var i in this.mylabel) {
                sort++;
                subsort=0;
                this.mylabel[i].sort=sort;
                for(var ii in this.mylabel[i].children) {
                    subsort++;
                    this.mylabel[i].children[ii].sort=subsort;
                }
            }

            //调整提交数据
            var data=[];
            for(var i=0;i<this.mylabel.length;i++) data.push(this.mylabel[i]);
            data=JSON.stringify(data);
            var loadingobj=this.$refs.PetXcxEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_SETTING.SAVE_XCX_CATE({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
            });

        },



        /** 修改选择系统属性 **/
       changeLabels(item,parentindex) {
           item.iselect=item.iselect==1 ? 0 : 1;        //勾选、取消勾选系统属性
           this.changeChildselect(item);                //递归勾选子集系统属性
           if(parentindex=='-1') {                      //没有上级时，不处理
               return false;      
           }else {                                      //有级的处理方式
                parentindex=parentindex.toString();
                this.changeParentselect(parentindex);
           }
       },


       /** 向上递归勾选父集 **/
       changeParentselect(indexs) {
           var labelinfo=this.labels[indexs];
           var children=labelinfo.children;
           var iselect=0;

           var nums=children.length;
           var noselect=0;
           var select=0;
           for(var i in children) {
               children[i].iselect==0 ? noselect++ : select++;
           }

           if(nums==select) iselect=1;
           if(noselect > 0 && select > 0) iselect=2;
           labelinfo.iselect=iselect;
           labelinfo.show=iselect==1 ? true : false;
       },


       /** 向下递归勾选子集 **/
       changeChildselect(item) {
           if(item.children.length==0) return false;
           var iselect=item.iselect;
           var show=item.show;
           for(var i in item.children) {
               item.children[i].iselect=iselect;
               item.children[i].show=show;
               if(item.children[i].children.length > 0) 
               this.changeChildselect(item.children[i].children); //如有子集继续往下递归执行
           }
       },


       /** 生成自定义属性 **/
       createAttribute() {
           var data=[];
           var datainfo={};
           var obj=this.labels;

           for(var i in obj) {
               if(obj[i].iselect > 0) {
                   datainfo={id:obj[i].id,name:obj[i].name,children:[]};
                   for(var ii in obj[i].children) {
                       if(obj[i].children[ii].iselect > 0) datainfo.children.push({id:obj[i].children[ii].id,name:obj[i].children[ii].name});
                   }
                   data.push(datainfo);
               }
           }

           //数据没有选择时
           if(data.length==0) {
               this.$notice({title:'错误提示',type:'warning',message:'请勾选属性信息'});
               return false;
           }

           this.mylabel=data;
       },


       /** 显示子集数据 **/
       showChild(id) {
           var obj=this.mylabel;
           var childs=[];
           for(var i in obj) {
                if(id==obj[i].id) childs=obj[i].children;
           }
           this.selectid=id;
           this.childs=childs;
       },

       /** 二级分类拖拽完成 **/
       finishchild() {
           var num;
           for(var i in this.mylabel) this.selectid==this.mylabel[i].id ? num=i : '';
           this.mylabel[num].children=this.childs;
       },


       /** 获取小程序自定义分类 **/
       GetXcxPetCate() {
           var loadingobj=this.$refs.PetXcxEdit;
           this.$loading.openloading(loadingobj);  //加载等待动画
           INTERFACE_SETTING.GET_XCX_CATE().then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.labels=res.data.sys ? res.data.sys : [];
                this.mylabel=res.data.custom ? res.data.custom : [];
           });
       },


    },
}
</script>
<style scoped>
.TTL-cate-infos {display:inline-block;width:100%;}
.TTL-cate-sys-1 {width:230px;display:inline-block;font-size:0;}
.TTL-cate-title {display: inline-block;width:100%;padding:10px 0;font-size:13px;letter-spacing: 2px;text-align: center;}
.TTL-cate-list {display:inline-block;width:100%;height: 420px;border-radius: 6px;border:1px solid #e5e5e8;overflow-y:auto;padding:0 0 20px 0;}
.TTL-cate-list::-webkit-scrollbar {width:0;}

.TTL-cate-label-1 {display:inline-block;width:100%;margin-top:15px;}
.TTL-cate-item {display:inline-flex;align-items: center;padding:0 20px;width:calc(100% - 40px);}
.TTL-cate-item .TTL-label-name {font-size:13px;letter-spacing: 2px;margin-left:15px;}
.TTL-cate-child {display:inline-block;padding:0 20px;width:calc(100% - 40px);}
::v-deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {height: 4px;top:7px;}

.TTL-cate-label-2 {display:inline-block;width:100%;margin-top:30px;cursor: pointer;}
.TTL-cate-label-2 .TTL-cate-item {display:inline-flex;align-items: center;padding:0 0;width:100%;}
.TTL-cate-label-2 .TTL-cate-item .TTL-label-name {font-size:14px;letter-spacing: 2px;margin-left:15px;font-weight: 550;}

.TTL-cate-label-3 {display:inline-block;width:100%;margin-top:20px;cursor: pointer;}
.TTL-cate-label-3 .TTL-cate-item {display:inline-flex;justify-content: left;align-items: center;padding:0 0;width:100%;margin-top:10px;}
.TTL-cate-label-3 .TTL-cate-child {display:inline-block;padding:0 0;width:100%;}
.TTL-cate-label-3 .TTL-cate-item .TTL-label-name {font-size:13px;letter-spacing: 2px;margin-left:15px;font-weight: normal;}
.TTL-cate-title i {font-style:normal;font-size:12px;color:red;}

.left40 {margin-left:100px;}
.drag-container {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
</style>